import { Page404 } from "./page404";
export default Page404;
